import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { FeatureDetails } from './pages/feature-details/feature-details';
import { getRoutePaths } from './core/config/route-paths';

export const routes: Routes = [
  {
    path: getRoutePaths().home,
    component: Home
  },
  {
    path: getRoutePaths().featureDetails,
    component: FeatureDetails
  }
];
